// extracted by mini-css-extract-plugin
export default {"stackRoot":"Layout_stackRoot__zWhiN","headerFooterRoot":"Layout_headerFooterRoot__NOXjc","bodyRoot":"Layout_bodyRoot__ygt8b"};